import React from "react";
import { Outlet } from "react-router-dom";
import ResidentSidebar from "../components/ResidentSidebar";
import "./ResidentLayout.css";

export default function ResidentLayout() {
  return (
    <div className="resident-layout-container">
      <ResidentSidebar />
      <div className="resident-layout-content">
        <Outlet />
      </div>
    </div>
  );
}
